import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function Location() {
  return <section className="py-24 bg-black-DEFAULT relative overflow-hidden" data-id="element-158">
      {/* Decorative Elements */}
      <div className="absolute right-0 top-0 w-1/3 h-full bg-gradient-to-l from-gray-900 to-transparent opacity-50" data-id="element-159" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-160">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-162">
            <div className="flex items-center gap-3 mb-6" data-id="element-163">
              <div className="p-3 bg-gold-500/10 rounded-full" data-id="element-164">
                <MapPin className="w-6 h-6 text-gold-500" data-id="element-165" />
              </div>
              <span className="text-gold-500 font-medium tracking-wider uppercase" data-id="element-166">
                Headquarters
              </span>
            </div>

            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-167">
              Dar es Salaam
            </h2>
            <div className="space-y-2 text-xl md:text-2xl text-gray-300 font-light" data-id="element-168">
              <p data-id="element-169">Bagamoyo Road</p>
              <p className="text-gray-500" data-id="element-170">Tanzania</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative aspect-video rounded-lg overflow-hidden border border-gray-800 bg-gray-900 group" data-id="element-171">
            {/* Abstract Map Representation */}
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2074&auto=format&fit=crop')] bg-cover bg-center opacity-40 grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-172" />
            <div className="absolute inset-0 bg-gradient-to-t from-black-rich via-transparent to-transparent" data-id="element-173" />

            <div className="absolute bottom-8 left-8" data-id="element-174">
              <p className="text-white font-bold text-lg" data-id="element-175">Visit Our Facility</p>
              <p className="text-gold-400 text-sm" data-id="element-176">Open Mon-Sat, 8am - 6pm</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}